import React from "react";
import styles from "./about.module.scss";

export const EventAbout = ({ goToBookNow, goToviewLocation, ...props }) => {
  return (
    <section>
      <div className="container">
        <div className={styles.about_container}>
          <div className="">
            <div className={styles.image_wrapper}>
              <img
                src="/assets/images/events/images/about-usa-admission-day.webp"
                alt="USA Admission Day"
              />
              <div className={styles.left_img_border_left}></div>
              <div className={styles.left_img_border_bottom}></div>
            </div>
          </div>
          <div className="">
            <h1 className={styles.about_heading}>
              About <br /> USA Admission Day
            </h1>
            <div className={styles.des_wrapper}>
              <p>
                Connect with representatives from US universities one to one to
                discover your ideal pathway for an education abroad! Receive
                personalized guidance from experts representing institutions
                like Avila University and Elmhurst University to make your study
                abroad dreams come true.
              </p>

              <div className={styles.left_border}></div>
            </div>
            <div className={styles.button_container}>
              <button
                onClick={goToviewLocation}
                className="btn btn-outline-grey btn-md"
              >
                View Location
              </button>

              <button
                onClick={goToBookNow}
                className="btn btn-secondary btn-md"
              >
                Book Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventAbout;
